var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRemoveCircle48Line = function SvgIconRemoveCircle48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.997 40.7a16.701 16.701 0 0 1-10.592-29.609 16.7 16.7 0 1 1 10.592 29.61Zm0-30A13.3 13.3 0 1 0 24 37.303a13.3 13.3 0 0 0-.003-26.601Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.987 22.3h-18v3.4h18v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconRemoveCircle48Line;